var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("FancySelect", {
    ref: "fancyselect",
    staticClass: "global-search-lookup",
    attrs: {
      options: _vm.options,
      loading: _vm.loading,
      value: _vm.selected,
      label: "label",
      filterable: false,
      clearable: false,
      placeholder: "Search donor name, donor ID, or pledge ID",
      noDrop: !_vm.query && !_vm.loading
    },
    on: { search: event => _vm.onSearch(event), input: _vm.handleInput },
    scopedSlots: _vm._u([
      {
        key: "option",
        fn: function(option) {
          return [
            option.type === "donor"
              ? [
                  _c("span", { staticClass: "option__type" }, [
                    _vm._v("Donor")
                  ]),
                  _c("span", [_vm._v(_vm._s(option.label))]),
                  _c("br"),
                  option.addressStr
                    ? _c("layoutText", { staticClass: "address" }, [
                        _vm._v(_vm._s(option.addressStr))
                      ])
                    : _vm._e()
                ]
              : option.type === "pledge"
              ? [
                  _c("span", { staticClass: "option__type" }, [
                    _vm._v("Pledge")
                  ]),
                  _c("span", [_vm._v(_vm._s(option.label))])
                ]
              : [_vm._v(_vm._s(option.label))]
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }